import { render } from "./CoursePdf.vue?vue&type=template&id=e3d7c164&scoped=true"
import script from "./CoursePdf.vue?vue&type=script&lang=js"
export * from "./CoursePdf.vue?vue&type=script&lang=js"

import "./CoursePdf.vue?vue&type=style&index=0&id=e3d7c164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d7c164"]])

export default __exports__